import { render, staticRenderFns } from "./SimpleKeyBoard.vue?vue&type=template&id=0a7ba3e8&scoped=true&"
import script from "./SimpleKeyBoard.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ba3e8",
  null
  
)

export default component.exports